import { OPEN_MAINMENU, CLOSE_MAINMENU, TOGGLE_MAINMENU } from './action-creators';
import { OPEN_RIGHTMENU, CLOSE_RIGHTMENU, TOGGLE_RIGHTMENU } from './../RightMenu/action-creators';
import { PAGE_LOAD } from '../CurrentPage/action-creators';
import { UPDATE_APP_SHELL_DATA } from '../../AppShell/action-creators';
export default function (state = null, action, appShellData) {
    if (state === null) {
        state = Object.assign({ isOpen: false, rightMenuIsOpen: false }, appShellData.mainMenu);
    }
    switch (action.type) {
        case OPEN_MAINMENU:
            return Object.assign({}, state, { isOpen: true });
        case CLOSE_MAINMENU:
            return Object.assign({}, state, { isOpen: false });
        case TOGGLE_MAINMENU: {
            return Object.assign({}, state, {
                isOpen: !state.isOpen,
            });
        }
        case OPEN_RIGHTMENU:
            return Object.assign({}, state, { rightMenuIsOpen: true });
        case CLOSE_RIGHTMENU:
            return Object.assign({}, state, { rightMenuIsOpen: false });
        case TOGGLE_RIGHTMENU: {
            return Object.assign({}, state, {
                rightMenuIsOpen: !state.rightMenuIsOpen,
            });
        }
        case UPDATE_APP_SHELL_DATA: {
            const updateAppShellDataAction = action;
            return Object.assign({ isOpen: state.isOpen, rightMenuIsOpen: state.rightMenuIsOpen }, updateAppShellDataAction.appShellData.mainMenu);
        }
        case PAGE_LOAD: {
            if (state.isOpen) {
                return Object.assign({}, state, {
                    isOpen: false,
                });
            }
            if (state.rightMenuIsOpen) {
                return Object.assign({}, state, {
                    rightMenuIsOpen: false,
                });
            }
            return state;
        }
        default:
            return state;
    }
}
